// extracted by mini-css-extract-plugin
module.exports = {"layout":"train_layout__3JrXg","legacyPageTitle":"train_legacyPageTitle__ixGsU"};